<template>
  <div class="cartItem" :class="{firstItem: itemList.firstItem}">
    <p v-if="!isTip" class="requestAt mb5 notranslate">
      <i class="orderId">{{locale.order_id}} {{itemList.order_id}}</i>
      <span v-if="paymentAmount && itemList.isPaid" class="isPaid"><img src="~@/assets/img/ico_paid.png" alt=""></span>
      <span class="paymentStatus">
      {{locale.order_time}}: {{datetimeFormat(itemList.createat)}}
      </span>
    </p>
    <p v-else class="requestAt mb5 notranslate">
      <i class="orderId">{{locale.tip}}</i>
    </p>

    <div class="inner">
      <div v-if="itemList.order_type === 'system_amenity'" class="mb10">{{locale.amenity}}</div>
      <div v-for="(item, index) in items"
        :key="index" class="itemInner">
        <!-- OrderItem과 OrderItem 내용이 모두 동일함 -->
        <OrderItem v-if="!isAmenity"
          :itemData="item"
          :locale="locale"
          :localeAmenity="localeAmenity"
          :lang="lang"
          :isTip="isTip" />
        <OrderItemAmenity v-else
          :itemData="item"
          :locale="locale"
          :localeAmenity="localeAmenity"
          :lang="lang" />
      </div>
      <div v-if="!isRoomChargePayment && paymentTotal" class="paymentBox" :class="{hiddenPrice: hiddenPrice}">
        <div v-if="paymentTotal.tax" class="taxPrice notranslate priceDpBoard">
          <div class="payInfo">
            <span class="label">{{locale.subtotal}}</span>
            <span class="value">{{priceFormat(paymentTotal.subtotal)}}</span>
          </div>
          <div class="payInfo">
            <span class="label">{{locale.tax}}({{paymentTotal.taxLabel}})</span>
            <span class="value">{{priceFormat(paymentTotal.tax)}}</span>
          </div>
        </div>
        <div class="payInfo notranslate priceDpBoard">
          <span class="label">{{locale.order_total_amount}}</span>
          <span class="value">{{priceFormat(paymentTotal.total)}}</span>
        </div>
      </div>
      <!-- <div class="btns notranslate">
        <button type="button" class="btn sizeS btnFull btnWhite">{{locale.cancel}}</button>
      </div> -->
      <div v-if="!statusDisabled">
        <div class="status toUppercase notranslate">
          <div v-for="(s, i) in status"
            :key="i"
            :class="{
              item: true,
              on: setStatus(i).on,
              active: setStatus(i).active,
            }"
            :data-status="i">
            <span class="label">{{getStatusName(s)}}</span>
          </div>
        </div>
        <p class="statusMessage colorGrey notranslate">{{locale.order_status_message}}</p>
      </div>
    </div>

    <div v-if="!isRoomChargePayment && paymentTotal" class="mypage-cart-item-total" :class="{hiddenPrice: hiddenPrice}" :style="defaultBtnStyle">
      <div v-if="paymentTotal.tax"></div>
      <div>
          <span class="label">{{locale.order_total_amount}}</span>
          <span class="value">{{priceFormat(paymentTotal.total)}}</span>
      </div>
      
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import { DateTime } from 'luxon'
import OrderItem from '@/components/Mypage/OrderItem'
import OrderItemAmenity from '@/components/Mypage/OrderItemAmenity'

export default {
  name: 'OrderListItem',
  props: [
    'lang',
    'locale',
    'itemList'
  ],
  components: {
    OrderItem,
    OrderItemAmenity
  },
  computed: {
    defaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    },
    localeAmenity () {
      return this.$store.state.system.localeAmenity.data
    },
    format () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      const time = 'HH:mm:ss'
      return `${date} ${time}`
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    items () {
      return Array.isArray(this.itemList.ordersheet) ? this.itemList.ordersheet : [this.itemList.ordersheet]
    },
    isRoomChargePayment () {
      return this.$route.name === 'roomCharge'
    },
    isTip () {
      return this.itemList.order_type === 'tip'
    },
    isAmenity () {
      return this.itemList.order_type === 'system_amenity'
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    paymentAmount () {
      const hasPrice = this.items.filter(x => x.price && x.price.info).length > 0
      const prices = hasPrice ? this.items.filter(x => x.price && x.price.info).map(x => x.price.info.total || 0) : null
      const sum = (a, b) => a + b
      return prices && prices.reduce(sum) > 0 ? prices.reduce(sum) : null
      // return prices
    },
    paymentTotal () {
      const hasPrice = this.items.filter(x => x.price && x.price.info && !x.price.info.noPrice).length > 0
      const prices = hasPrice ? this.items.filter(x => x.price && x.price.info).map(x => x.price.info) : null
      const tax = prices ? prices.map(x => x.tax) : null
      const taxLabel = prices && tax ? prices[0].subtotal / prices[0].tax : null
      const subtotal = prices ? prices.map(x => x.subtotal) : null
      const total = prices ? prices.map(x => x.total) : null
      const sum = (a, b) => a + b
      return hasPrice && prices && total >= 0
        ? {
          ...tax.length > 0 && { tax: tax.reduce(sum), taxLabel: `${taxLabel}%` },
          ...subtotal.length > 0 && { subtotal: subtotal.reduce(sum) },
          total: total.reduce(sum)
        } : null
    },
    statusDisabled () {
      const setting = this.$store.getters['common/getSetting']
      return setting && setting.order && setting.order.progressDisabled
    },
    hiddenPrice () {
      return this.items && this.items.find(x => x.hiddenPrice)
    }
  },
  data () {
    return {
      status: [
        'ready',
        'progress',
        'delivery',
        'complete',
        'cancel'
      ]
    }
  },
  methods: {
    datetimeFormat (iso) {
      const datetime = DateTime.fromISO(iso, { zone: this.timezone })
      return datetime.toFormat(this.format)
    },
    priceFormat (price) {
      const code = this.currencyCode
      return regExp.priceFormat(price, code)
    },
    getStatusName (status) {
      const statusName = `status_${status}`
      return this.locale[statusName]
    },
    setStatus (index) {
      const orderStatus = this.itemList.order_status
      const statusIndex = this.status.findIndex(x => x === orderStatus)
      const isOn = statusIndex === 4
        ? index === 4
        : statusIndex >= index
      const isActive = statusIndex === index
      return {
        on: isOn,
        active: isActive
      }
    },
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    }
  }
}
</script>

<style lang="scss" scoped>
.statusMessage {
  width: 100%;
  margin-top: 1em;
  text-align: center;
  font-size: 12px;
  opacity: 0.5;
  &:before {
    content: "* ";
  }
}
.status {
  .item[data-status="4"] {
    display: none;
    &.active {
      display: initial;
    }
  }
}
.mypage-cart-item-total{
  display: none;
}
</style>
